<template>
  <div class="search">
    <div id="centercolumn" class="small-12 large-12 columns">
      <div>
        <img
          src="https://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/images/KIM_banner.jpg"
          style="margin-bottom:20px;"
        />
      </div>
      <form v-on:submit.prevent="submit">
        <div class="formContainer">
          <div class="searchOuterWrapper container row">
            <div class="searchInnerWrapper small-12 large-12 columns">
              <b>Search Keywords:</b>
              <button
                @click="submit()"
                class="gb_8e gb_if"
                aria-label="Search KIM Library"
                role="button"
              >
                <svg
                  focusable="false"
                  height="24px"
                  viewBox="0 0 24 24"
                  width="24px"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
                  />
                  <path d="M0 0h24v24H0z" fill="none" />
                </svg>
              </button>
              <input
                id="searchText"
                v-model="searchText"
                placeholder="Search..."
                size="70"
                type="text"
                class="gci_pub_input"
                name="keywords"
              />
              <span class="kipLink">
                <a
                  href="https://www.getty.edu/foundation/initiatives/current/keeping_it_modern/"
                  target="_blank"
                  >More about Keeping It Modern grants</a
                >
              </span>
              <br />
            </div>
          </div>
          <!-- TODO BUILD BY ARRAY RATHER THAN BY HAND DO THIS WHEN YOU AHVE A MOMEMT WITH this.formarr -->
          <!--
                  <div class="btnWrapper container row">
                    <div v-for="(value, index) in this.formArr" :key="`${index}-header`" class="small-12 medium-4 large-4 columns" data-name='materials' style="margin-top:0px;">
                      <h6 class="h6 type-header" v-on:click="toggleHide('dropdown' + index)" :ref="'dropdown' + index" :id="'dropdown' + index">{{value.header}}<span class="icon">˅</span></h6>
                      <ul :class="{'hide': value.class}">
                          <li v-for="(v, i) in value.items" :key="`${i}-items`">
                            <label :for="'box'+i" class="radio-btn">
                            <input v-model="attributes[value.array]"  :id="'box'+i" :name="'box'+i" type="checkbox" @change="handleChange('box'+i)" :value="v.val">
                            <span :ref="'box'+i">{{v.data}}</span>
                            </label>
                          </li>
                      </ul>
                   </div>
                  </div>
          -->
          <!-- TODO BUILD BY ARRAY RATHER THAN BY HAND DO THIS WHEN YOU AHVE A MOMEMT WITH this.formarr -->
          <div class="btnWrapper container row">
            <div
              class="small-12 medium-4 large-4 columns"
              data-name="materials"
              style="margin-top:0px;"
            >
              <h6
                class="h6 type-header"
                v-on:click="toggleHide('dropdown3')"
                ref="dropdown3"
                id="dropdown3"
              >
                Building Type
                <span class="icon">˅</span>
              </h6>
              <ul :class="{ hide: this.hide3 }">
                <li>
                  <label for="box17" class="radio-btn">
                    <input
                      v-model="attributes.buildings"
                      id="box17"
                      name="box17"
                      type="checkbox"
                      @change="handleChange('box17')"
                      value="edu"
                    />
                    <span ref="box17">Educational</span>
                  </label>
                </li>
                <li>
                  <label for="box16" class="radio-btn">
                    <input
                      v-model="attributes.buildings"
                      id="box16"
                      name="box16"
                      type="checkbox"
                      @change="handleChange('box16')"
                      value="ctr"
                    />
                    <span ref="box16">Cultural</span>
                  </label>
                </li>
                <li>
                  <label for="box15" class="radio-btn">
                    <input
                      v-model="attributes.buildings"
                      id="box15"
                      name="box15"
                      type="checkbox"
                      @change="handleChange('box15')"
                      value="ens"
                    />
                    <span ref="box15">Scientific &amp; Health</span>
                  </label>
                </li>
                <li>
                  <label for="box14" class="radio-btn">
                    <input
                      v-model="attributes.buildings"
                      id="box14"
                      name="box14"
                      type="checkbox"
                      @change="handleChange('box14')"
                      value="gvb"
                    />
                    <span ref="box14">Government</span>
                  </label>
                </li>
                <li>
                  <label for="box13" class="radio-btn">
                    <input
                      v-model="attributes.buildings"
                      id="box13"
                      name="box13"
                      type="checkbox"
                      @change="handleChange('box13')"
                      value="rlg"
                    />
                    <span ref="box13">Religious</span>
                  </label>
                </li>
                <li>
                  <label for="box12" class="radio-btn">
                    <input
                      v-model="attributes.buildings"
                      id="box12"
                      name="box12"
                      type="checkbox"
                      @change="handleChange('box12')"
                      value="rsd"
                    />
                    <span ref="box12">Residential</span>
                  </label>
                </li>
                <li>
                  <label for="box11" class="radio-btn">
                    <input
                      v-model="attributes.buildings"
                      id="box11"
                      name="box11"
                      type="checkbox"
                      @change="handleChange('box11')"
                      value="snr"
                    />
                    <span ref="box11">Sports &amp; Recreation</span>
                  </label>
                </li>
              </ul>
            </div>
            <div
              class="small-12 medium-4 large-4 columns"
              data-name="materials"
            >
              <h6
                class="h6 type-header"
                v-on:click="toggleHide('dropdown2')"
                ref="dropdown2"
                id="dropdown2"
              >
                Materials
                <span class="icon">˅</span>
              </h6>
              <ul :class="{ hide: this.hide2 }">
                <li>
                  <label for="box10" class="radio-btn">
                    <input
                      v-model="attributes.materials"
                      id="box10"
                      name="box10"
                      type="checkbox"
                      @change="handleChange('box10')"
                      value="brk"
                    />
                    <span ref="box10">Brick</span>
                  </label>
                </li>
                <li>
                  <label for="box9" class="radio-btn">
                    <input
                      v-model="attributes.materials"
                      id="box9"
                      name="box9"
                      type="checkbox"
                      @change="handleChange('box9')"
                      value="cnc"
                    />
                    <span ref="box9">Concrete</span>
                  </label>
                </li>
                <li>
                  <label for="box8" class="radio-btn">
                    <input
                      v-model="attributes.materials"
                      id="box8"
                      name="box8"
                      type="checkbox"
                      @change="handleChange('box8')"
                      value="gls"
                    />
                    <span ref="box8">Glass</span>
                  </label>
                </li>
                <li>
                  <label for="box7" class="radio-btn">
                    <input
                      v-model="attributes.materials"
                      id="box7"
                      name="box7"
                      type="checkbox"
                      @change="handleChange('box7')"
                      value="pnt"
                    />
                    <span ref="box7">Paint</span>
                  </label>
                </li>
                <li>
                  <label for="box5" class="radio-btn">
                    <input
                      v-model="attributes.materials"
                      id="box5"
                      name="box5"
                      type="checkbox"
                      @change="handleChange('box5')"
                      value="tle"
                    />
                    <span ref="box5">Tile</span>
                  </label>
                </li>
                <li>
                  <label for="box4" class="radio-btn">
                    <input
                      v-model="attributes.materials"
                      id="box4"
                      name="box4"
                      type="checkbox"
                      @change="handleChange('box4')"
                      value="wod"
                    />
                    <span ref="box4">Wood</span>
                  </label>
                </li>
                <li>
                  <label for="box3" class="radio-btn">
                    <input
                      v-model="attributes.materials"
                      id="box3"
                      name="box3"
                      type="checkbox"
                      @change="handleChange('box3')"
                      value="stl"
                    />
                    <span ref="box3">Metal</span>
                  </label>
                </li>
                <li>
                  <label for="box2" class="radio-btn">
                    <input
                      v-model="attributes.materials"
                      id="box2"
                      name="box2"
                      type="checkbox"
                      @change="handleChange('box2')"
                      value="stn"
                    />
                    <span ref="box2">Stone</span>
                  </label>
                </li>
              </ul>
            </div>
            <div
              class="small-12 medium-4 large-4 columns"
              data-name="report_type"
            >
              <h6
                class="h6 type-header"
                v-on:click="toggleHide('dropdown1')"
                ref="dropdown1"
                id="dropdown1"
              >
                Report Type
                <span class="icon">˅</span>
              </h6>
              <ul :class="{ hide: this.hide1 }">
                <li>
                  <label for="box1" class="radio-btn">
                    <input
                      v-model="attributes.reports"
                      id="box1"
                      name="box1"
                      type="checkbox"
                      @change="handleChange('box1')"
                      value="cps"
                    />
                    <span ref="box1">Conservation &amp; management plans</span>
                  </label>
                </li>
                <li>
                  <label for="box0" class="radio-btn">
                    <input
                      v-model="attributes.reports"
                      id="box0"
                      name="box0"
                      type="checkbox"
                      @change="handleChange('box0')"
                      value="trp"
                    />
                    <span ref="box0">Technical studies</span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
          <div class="row container">
            <div
              id="display_filters"
              style="padding-bottom:10px; padding-top:5px;"
              class="small-12 large-12 columns"
            >
              <span style="font-size: 12px;">
                <b>Filtered by:</b>
              </span>
              <div
                id="filters_display"
                style="font-size: 12px; margin:0px 0px 0px 5px; display:inline;line-height: 20px;"
              >
                {{ this.textTypes }}
              </div>
            </div>
          </div>
          <div class="inputWrapper container">
            <input
              type="submit"
              value="Search"
              id="submit"
              class="gci_pub_button search_button s_button"
            />
            <input
              class="gci_pub_button search_button r_button"
              type="reset"
              value="Clear Search"
              id="resetFilter"
              @click="
                selected = null;
                filterReset();
              "
            />
          </div>
        </div>
      </form>
      <div class="searchResults" :class="{ hide: this.hide }">
        <div class="flex-wrap">
          <div class="searchResultsInfo">
            Found {{ this.searchTotals }} results.
            <span v-if="this.searchTotals !== 0"
              >Showing results {{ this.startResults }} to {{ this.endResults }}.
              Page {{ this.currentPage }} of {{ this.totalPages }}</span
            >
          </div>
          <div class="pagination" v-if="this.searchTotals !== 0">
            <span v-on:click="prevButton" v-if="this.fromValue !== 0"
              >&lt; Previous</span
            >
            <span
              v-on:click="nextButton"
              v-if="this.currentPage !== this.totalPages"
              >Next &gt;</span
            >
          </div>
          <div class="sort" v-if="this.searchTotals !== 0">
            <select
              name="alphasort"
              id="alphasort"
              ref="alphasort"
              v-model="sortKey"
              v-on:change="sortBy(sortKey)"
            >
              <option value selected disabled>Sort By</option>
              <option value="architect">Architect</option>
              <option value="country">Country</option>
              <option value="yearbuildingcompleted"
                >Year Building Completed</option
              >
            </select>
          </div>
        </div>
        <hr />
        <table>
          <tbody>
            <tr>
              <td class="resultsTableData">
                <div
                  v-for="result in searchResults"
                  :key="result._id"
                  class="mediaWrapper"
                >
                  <div class="media">
                    <div class="media-left">
                      <div
                        v-if="result._source.image !== undefined"
                        class="media-object"
                        v-bind:style="{
                          backgroundImage:
                            'url(https://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/images/' +
                            result._source.image +
                            ')'
                        }"
                        style="height:75px;width:75px;"
                      ></div>
                      <div
                        v-else
                        class="media-object"
                        style="background-image:url(http://via.placeholder.com/75x75);height:75px;width:75px;"
                      ></div>
                    </div>
                    <div class="media-body">
                      <span
                        v-if="
                          result._source.title !== undefined ||
                            result._source.title !== ''
                        "
                      >
                        <b>
                          <a
                            v-if="
                              result._source.title ===
                                'Preservation of Modern Architecture: Studies for the Arthur Neiva Pavilion Preventive Conservation P'
                            "
                            class="title"
                            :href="
                              result._source.url.replace(
                                'www.getty.edu/foundation/kim/',
                                'www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/'
                              ) +
                                '?q=' +
                                JSON.stringify($route.query)
                            "
                            >Preservation of Modern Architecture: Studies for
                            the Arthur Neiva Pavilion Preventive Conservation
                            Plan</a
                          >
                          <a
                            v-else
                            class="title"
                            :href="
                              result._source.url.replace(
                                'www.getty.edu/foundation/kim/',
                                'www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/'
                              ) +
                                '?q=' +
                                JSON.stringify($route.query)
                            "
                            >{{ result._source.title }}</a
                          >
                        </b>
                      </span>
                      <span v-else>
                        <b>
                          <a
                            class="title"
                            :href="
                              result._source.url.replace(
                                'www.getty.edu/foundation/kim/',
                                'www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/'
                              ) +
                                '?q=' +
                                JSON.stringify($route.query)
                            "
                            >No Title</a
                          >
                        </b>
                      </span>
                      <br />
                      <p v-if="result._source['architect'] !== ''">
                        <b>Architect:</b>
                        {{ result._source["architect"] }}
                      </p>
                      <p v-if="result._source['country'] !== ''">
                        <b>Country:</b>
                        {{ result._source["country"] }}
                      </p>
                      <p v-if="result._source['yearbuildingcompleted'] !== ''">
                        <b>Year Building Completed:</b>
                        {{ result._source["yearbuildingcompleted"] }}
                      </p>
                    </div>
                  </div>
                  <br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pagination" v-if="this.searchTotals !== 0">
          <span v-on:click="prevButton" v-if="this.fromValue !== 0"
            >&lt; Previous</span
          >
          <span
            v-on:click="nextButton"
            v-if="this.currentPage !== this.totalPages"
            >Next &gt;</span
          >
        </div>
      </div>
      <!-- swiper -->
      <div style="clear:both;padding-top: 10px;">
        <h4 class="h4" style="margin:0;" :class="{ hide: this.hideSlider }">
          Featured Projects
        </h4>
        <br />
        <swiper :options="swiperOption" :class="{ hide: this.hideSlider }">
          <swiper-slide
            v-for="(slide, index) in this.swiperSlides"
            :key="index"
          >
            <a
              :alt="slide.url"
              :title="slide.url"
              :href="slide.url"
              :style="{ backgroundImage: 'url(' + slide.img + ')' }"
              style="padding-bottom:67.7%; width:100%; display:block; position:relative;"
            >
              <p class="caption">{{ slide.caption }}</p>
            </a>
          </swiper-slide>
          <div class="swiper-button-prev buttons" slot="button-prev">&#60;</div>
          <div class="swiper-button-next buttons" slot="button-next">&#62;</div>
        </swiper>
      </div>
      <div class="open" id="terms" style="margin: 10px 0px;">
        <a href="#" data-toggle="modal" data-target="#myModal">
          TERMS OF USE
          <span class="arrow-right"></span>
        </a>
        <span style="float:right;"
          >Report Database Updated: {{ this.lastUpdated }}</span
        >
      </div>
      <div class="container">
        <!-- Modal -->
        <div
          class="modal"
          id="myModal"
          role="dialog"
          style="background: rgba(0, 0, 0,0.75);"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <iframe
                  style="width: 100%;height: 50vh;"
                  src="https://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/terms.html"
                  frameborder="0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
// Support for window.fetch and window.btoa for Internet Explorer 9+
import base64 from "base64-js";
import "isomorphic-fetch";
require("es6-promise").polyfill();

export default {
  name: "SearchKIM",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 30,
        freeMode: true,
        loop: true,
        slidesPerView: 3,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 30
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }
      },
      swiperSlides: [
        {
          img: require("@/assets/sydney_opera.jpg"),
          url:
            "http://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/sydney.html",
          caption: "Sydney Opera House. Image courtesy Susan MacDonald",
          title: "Sydney Opera House"
        },
        {
          img: require("@/assets/gandhi_bhawan.jpg"),
          url:
            "http://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/gandhi_bhawan.html",
          caption:
            "Gandhi Bhawan by Pierre Jeanneret. © Vanicka Arora, Associate Architect, DRONAH",
          title: "Gandhi Bhawan"
        },
        {
          img: require("@/assets/einstein_tower.jpg"),
          url:
            "http://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/einstein_tower.html",
          caption:
            "The Solar Observatory Einstein Tower on the Telegrafenberg in Potsdam. Photo by J. Rendtel / Leibniz Institute for Astrophysics Potsdam (AIP)",
          title: "Einstein Tower"
        },
        {
          img: require("@/assets/salk_institute.jpg"),
          url:
            "http://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/salk_institute.html",
          caption:
            "Salk Institute for Biological Studies. Photo © Elizabeth Daniels",
          title: "Salk Institute for Biological Studies"
        },
        {
          img: require("@/assets/luce_chapel.jpg"),
          url:
            "http://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/luce_chapel.html",
          caption:
            "Henry Luce Memorial Chapel. Image courtesy Tunghai University",
          title: "Luce Chapel"
        },
        {
          img: require("@/assets/gropius_house.jpg"),
          url:
            "http://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/gropius_house.html",
          caption:
            "Exterior of Historic New England's Gropius House in Lincoln, Massachusetts. Image courtesy Historic New England",
          title: "Gropius House"
        },
        {
          img: require("@/assets/cristo_obrero.jpg"),
          url:
            "http://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/cristo_obrero_church.html",
          caption: "Cristo Obrero Church. Photograph © Leonardo Finotti",
          title: "Cristo Obrero"
        },
        {
          img: require("@/assets/Paimio_1045_20141663_3of4.jpg"),
          url:
            "http://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/paimio_sanatorium.html",
          caption:
            "Paimio Sanatorium, patients' wing and solarium terraces. Photo: Maija Holma, Alvar Aalto Museum",
          title: "Paimio"
        },
        {
          img: require("@/assets/Centennial_hall_1045_20141753_6of10.jpg"),
          url:
            "http://www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/centennial_hall.html",
          caption:
            "Centennial Hall, interior, ribs of the dome and lantern, photograph ca. 1920. Photo: Museum of Architecture in Wrocław",
          title: "Centennial Hall"
        }
      ],
      searchText: "",
      attributes: {
        buildings: [],
        materials: [],
        reports: []
      },
      formArr: [
        {
          header: "Report Type",
          array: "reports",
          class: this.hide1,
          items: [
            {
              data: "Conservation & management plans",
              val: "cps"
            },
            {
              data: "Technical studies",
              val: "trp"
            }
          ]
        },
        {
          header: "Materials",
          array: "materials",
          class: this.hide2,
          items: [
            {
              data: "Brick",
              val: "brk"
            },
            {
              data: "Concrete",
              val: "cnc"
            },
            {
              data: "Glass",
              val: "gls"
            },
            {
              data: "Paint",
              val: "pnt"
            },
            {
              data: "Metal",
              val: "stl"
            },
            {
              data: "Tile",
              val: "tle"
            },
            {
              data: "Wood",
              val: "wod"
            },
            {
              data: "Stone",
              val: "stn"
            }
          ]
        },
        {
          header: "Building Type",
          array: "buildings",
          class: this.hide3,
          items: [
            {
              data: "Cultural",
              val: "ctr"
            },
            {
              data: "Scientific & Health",
              val: "ens"
            },
            {
              data: "Educational",
              val: "edu"
            },
            {
              data: "Government",
              val: "gvb"
            },
            {
              data: "Religious",
              val: "rlg"
            },
            {
              data: "Residential",
              val: "rsd"
            }
          ]
        }
      ],
      inputUrl: "",
      searchTotals: "",
      searchResults: [],
      types: [],
      textTypes: "",
      fromValue: 0,
      sizeValue: 50,
      startResults: 1,
      endResults: 50,
      currentPage: 1,
      endPage: 1,
      totalPages: 1,
      selected: null,
      filterBy: "",
      sortKey: "",
      lastUpdated: "",
      hide: true,
      hide1: true,
      hide2: true,
      hide3: true,
      hideSlider: false,
      routeInputUrl: this.$route.query.input,
      routeFilter: this.$route.query.filter,
      refArr: [],
      checkedBoxes: [],
      checkBoxArr: [
        {
          data: "Cultural",
          val: "ctr"
        },
        {
          data: "Scientific & Health",
          val: "ens"
        },
        {
          data: "Educational",
          val: "edu"
        },
        {
          data: "Government",
          val: "gvb"
        },
        {
          data: "Religious",
          val: "rlg"
        },
        {
          data: "Residential",
          val: "rsd"
        },
        {
          data: "Sports & Recreation",
          val: "snr"
        },
        {
          data: "Brick",
          val: "brk"
        },
        {
          data: "Concrete",
          val: "cnc"
        },
        {
          data: "Glass",
          val: "gls"
        },
        {
          data: "Paint",
          val: "pnt"
        },
        {
          data: "Metal",
          val: "stl"
        },
        {
          data: "Tile",
          val: "tle"
        },
        {
          data: "Wood",
          val: "wod"
        },
        {
          data: "Stone",
          val: "stn"
        },
        {
          data: "Conservation & management plans",
          val: "cps"
        },
        {
          data: "Technical studies",
          val: "trp"
        }
      ]
    };
  },
  computed: {
    // create swiper ref
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    // init submit with currentPage set to 1
    lastUpdate: function() {
      let headers = new Headers();
      headers.append(
        "Authorization",
        "Basic " +
          btoa(
            "search:tvpSR7ErnJbfjpuw5Ez8PFAL3JygfzLeeUMrE8R7tuyv7QHnJAJhCjHbgUfUTamT"
          )
      );
      fetch(
        "https://df7507c78002407abc59103bde67005c.us-west-1.aws.found.io:9243/index/_search?q=(*)AND(url:%22www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/%22)NOT(url:%22www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/terms.html%22)NOT(url:%22www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/st_johns_test.html%22)?scroll=1m&size=50&from=0",
        { headers: headers }
      )
        .then(response => response.json())
        .then(json => {
          this.lastUpdated = json.hits.hits[0]._source.tstamp;
        });
    },
    // init submit with currentPage set to 1
    submit: function() {
      this.sortKey = "";
      this.hide = false;
      this.hideSlider = true;
      this.toggleFilters();
      this.searchTextFilter();
      this.fromValue = 0;
      this.currentPage = 1;
      let headers = new Headers();
      headers.append(
        "Authorization",
        "Basic " +
          btoa(
            "search:tvpSR7ErnJbfjpuw5Ez8PFAL3JygfzLeeUMrE8R7tuyv7QHnJAJhCjHbgUfUTamT"
          )
      );
      fetch(
        encodeURI(
          "https://df7507c78002407abc59103bde67005c.us-west-1.aws.found.io:9243/index/_search" +
            this.inputUrl +
            'AND(url:"www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/")NOT(url:"www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/terms.html")NOT(url:"www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/st_johns_test.html")?scroll=1m&size=' +
            this.sizeValue +
            "&from=" +
            this.fromValue
        ),
        { headers: headers }
      )
        .then(response => response.json())
        .then(json => {
          this.searchResults = this.uniqBy(json.hits.hits, "_source", "title");
          this.searchTotals = this.searchResults.length;
          this.totalPages = Math.ceil(this.searchResults.length / 50);
          /* this.$router
            .replace({
              name: "Search",
              query: {
                q: this.searchText,
                buildings: JSON.stringify(this.attributes.buildings),
                materials: JSON.stringify(this.attributes.materials),
                reports: JSON.stringify(this.attributes.reports)
              }
            })
            .catch(err => {
              console.error(err);
            }); */
          this.resultsCalc();
        });
    },
    // submitForm as above, but expanded to take in from and size and no initial currentPage set, mainly used in next & previous buttons
    submitForm: function(from, size) {
      this.sortKey = "";
      this.toggleFilters();
      this.searchTextFilter();
      this.hide = false;
      this.hideSlider = true;
      let headers = new Headers();
      headers.append(
        "Authorization",
        "Basic " +
          btoa(
            "search:tvpSR7ErnJbfjpuw5Ez8PFAL3JygfzLeeUMrE8R7tuyv7QHnJAJhCjHbgUfUTamT"
          )
      );
      fetch(
        encodeURI(
          "https://df7507c78002407abc59103bde67005c.us-west-1.aws.found.io:9243/index/_search" +
            this.inputUrl +
            'AND(url:"www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/")NOT(url:"www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/terms.html")NOT(url:"www.getty.edu/foundation/initiatives/current/keeping_it_modern/report_library/st_johns_test.html")?scroll=1m&size=' +
            size +
            "&from=" +
            from
        ),
        { headers: headers }
      )
        .then(response => response.json())
        .then(json => {
          this.searchResults = this.uniqBy(json.hits.hits, "_source", "title");
          this.searchTotals = this.searchResults.length;
          this.totalPages = Math.ceil(this.searchTotals / 50);
          /* this.$router
            .replace({
              path: "/",
              name: "Search",
              query: {
                q: this.searchText,
                buildings: JSON.stringify(this.attributes.buildings),
                materials: JSON.stringify(this.attributes.materials),
                reports: JSON.stringify(this.attributes.reports)
              }
            })
            .catch(err => {
              console.error(err);
            }); */
          this.resultsCalc();
        });
    },
    // filter search results and append filter and push/pull results from url
    searchTextFilter: function() {
      if (this.searchText.length !== 0) {
        this.inputUrl = '?q=("' + this.searchText + '")' + this.filterBy;
        // this.$router.push({ query: { q: this.searchText } })
      } else if (this.$route.query.length !== 0) {
        if (
          typeof this.$route.query.q === "undefined" ||
          this.$route.query.q === ""
        ) {
          this.inputUrl = "?q=(*)" + this.filterBy;
          // this.$router.push({ query: { q: this.searchText } })
        } else {
          this.inputUrl = '?q=("' + this.$route.query.q + '")' + this.filterBy;
          this.searchText = this.$route.query.q;
        }
      } else {
        this.inputUrl = "?q=(*)" + this.filterBy;
        // this.$router.push({ query: { q: this.searchText } })
      }
    },
    // calc resutls depending if page is 0, less then 50 or over 50
    resultsCalc: function() {
      if (this.fromValue === 0) {
        if (this.searchResults.length === 0) {
          this.startResults = 0;
          this.endResults = 0;
          this.currentPage = 0;
          this.endPage = 0;
        } else {
          if (this.searchResults.length < 50) {
            this.startResults = 1;
            this.endResults = this.searchTotals;
          } else {
            this.startResults = 1;
            this.endResults = this.fromValue + 50;
          }
        }
      } else {
        if (this.searchResults.length !== 0) {
          this.startResults = this.fromValue;
          this.endResults = this.fromValue + 50;
        }
        if (this.currentPage === this.totalPages) {
          this.endResults = this.searchTotals;
        }
      }
    },
    // function to move the page back 50 results
    prevButton: function() {
      this.fromValue -= 50;
      this.currentPage -= 1;
      this.submitForm(this.fromValue, this.sizeValue, true);
    },
    // function to move page forward 50 results
    nextButton: function() {
      this.fromValue = 50 + this.fromValue;
      this.currentPage += 1;
      this.submitForm(this.fromValue, this.sizeValue, true);
    },
    // Add or remove checkboxes to the query
    toggleFilters: function() {
      this.filterBy = "";
      if (
        this.attributes.buildings.length > 0 ||
        this.attributes.materials.length > 0 ||
        this.attributes.reports.length > 0
      ) {
        this.filterBy += "AND" + this.filterBy;
        if (this.attributes.buildings.length > 0) {
          this.filterBy += this.attributes.buildings.map(building => {
            return '(meta.buildingtype="' + building + '")';
          });
        }
        if (this.attributes.materials.length > 0) {
          this.filterBy += this.attributes.materials.map(material => {
            return '(meta.materials="' + material + '")';
          });
        }
        if (this.attributes.reports.length > 0) {
          this.filterBy += this.attributes.reports.map(report => {
            return '(meta.reporttype="' + report + '")';
          });
        }
      }
      return this.filterBy;
    },
    // toggle checkboxes visibilty
    toggleHide: function(ref) {
      if (ref) {
        switch (ref) {
          case "dropdown1":
            this.hide1 = !this.hide1;
            break;
          case "dropdown2":
            this.hide2 = !this.hide2;
            break;
          case "dropdown3":
            this.hide3 = !this.hide3;
            break;
        }
      }
    },
    // reset filter function
    filterReset: function() {
      this.filterBy = "";
      this.types = [];
      this.textTypes = "";
      this.checkedBoxes = [];
      this.refArr = [];
      this.attributes.buildings = [];
      this.attributes.materials = [];
      this.attributes.reports = [];
      this.searchText = "";
      this.routeInputUrl = "";
      this.inputUrl = "";
      this.routeFilter = "";
      this.hide = true;
      this.hideSlider = false;
      this.sortKey = "";
      /*this.$router
        .replace({
          path: "/",
          name: "Search"
        })
        .catch(err => {
          console.error(err);
        }); */
    },
    // Get value from checkbox
    handleChange: function() {
      this.types = [];
      this.checkedBoxes = [
        ...this.attributes.buildings,
        ...this.attributes.materials,
        ...this.attributes.reports
      ];
      this.checkedBoxes.forEach(v => {
        this.convertVal(v);
      });
      this.textTypes = this.types.toString().replace(/,/g, ", ");
      return this.textTypes;
    },
    // Convert value to text content for display on page
    convertVal: function(val) {
      this.checkBoxArr.forEach(v => {
        if (v.val === val) {
          this.types.push(v.data);
        }
      });
      return this.types;
    },
    // Sort alphanumerically if architect by last name
    sortBy: function(sortKey) {
      this.searchResults.sort(function(a, b) {
        if (sortKey === "architect") {
          let splitA = a._source[sortKey].trim().split(" ");
          let splitB = b._source[sortKey].trim().split(" ");
          if (splitA[splitA.length - 1] < splitB[splitB.length - 1]) return -1;
          if (splitA[splitA.length - 1] > splitB[splitB.length - 1]) return 1;
        } else {
          if (a._source[sortKey] < b._source[sortKey]) return -1;
          if (a._source[sortKey] > b._source[sortKey]) return 1;
        }
        return 0;
      });
    },
    uniqBy(myArr, prop, prop2) {
      return myArr.filter((obj, pos, arr) => {
        if (obj[prop][prop2] !== "Getty Foundation | The Getty") {
          return (
            arr.map(mapObj => mapObj[prop][prop2]).indexOf(obj[prop][prop2]) ===
            pos
          );
        }
      });
    }
  },
  created() {
    // Load Query paramets if object is avaiable also submit query
    this.lastUpdate();
    if (
      !(
        Object.keys(this.$route.query).length === 0 &&
        this.$route.query.constructor === Object
      )
    ) {
      this.attributes.buildings = JSON.parse(this.$route.query.buildings);
      this.attributes.materials = JSON.parse(this.$route.query.materials);
      this.attributes.reports = JSON.parse(this.$route.query.reports);
      this.searchText =
        this.$route.query.q !== undefined ? this.$route.query.q : "";
      this.handleChange();
      this.submitForm(0, 50, false);
    }
  },
  mounted() {
    let self = this;
    window.addEventListener("resize", () => {
      if (window.innerWidth > 568) {
        this.hide1 = false;
        this.hide2 = false;
        this.hide3 = false;
      } else {
        this.hide1 = true;
        this.hide2 = true;
        this.hide3 = true;
      }
    });
    window.onload = function() {
      if (window.innerWidth > 568) {
        self.hide1 = false;
        self.hide2 = false;
        self.hide3 = false;
      }
      if (!window.btoa) window.btoa = base64.encode;
      if (!window.atob) window.atob = base64.decode;
    };
    this.submit();
  }
};
</script>

<style lang="scss" scoped>
a {
  color: #337ab7;
  font-weight: 600;
  text-decoration: none;
}
</style>
